import validator from '../../shared/validator';
import {XeroSignupAction} from '../actions';
import {DEFAULT_STATE, XeroSignupState} from '../state';
import {KeyValue} from '../types/Types';
import {isEmpty} from 'lodash';

export function xeroSignupReducer(
  state: XeroSignupState<string> = DEFAULT_STATE,
  action: XeroSignupAction
): XeroSignupState<string> {
  switch (action.type) {
    case 'xeroSignup/INIT': {
      const {signupRequestId, source, signupOrigin} = action.payload;
      return {
        ...state,
        signupRequestId,
        source,
        signupOrigin,
      };
    }

    case 'xeroSignup/RECEIVE': {
      const {content} = action.payload;
      let displayCountryAndTimeZone = state.displayCountryAndTimeZone;
      if (content.formData && content.formData.countryCode === 'AU') {
        displayCountryAndTimeZone = true;
      }
      return {
        ...state,
        displayCountryAndTimeZone,
        ...content,
      };
    }

    case 'xeroSignup/UPDATE_FIELD': {
      const newField = {
        ...state.formData,
        ...action.payload,
      };

      const changeValidationRules =
        state.formData.phoneCountryCodePrefix ===
        newField.phoneCountryCodePrefix;

      let validationRules = state.validationRules;
      if (newField.phoneCountryCodePrefix === '+61') {
        validationRules = {
          ...validationRules,
          item: {
            ...validationRules.item,
            phone: {required: true, minLength: 9},
          },
        };
      } else {
        validationRules = {
          ...validationRules,
          item: {
            ...validationRules.item,
            phone: {required: true},
          },
        };
      }
      let errors: KeyValue | null = null;
      if (
        (state.hasSaved && changeValidationRules) ||
        !isEmpty(state.errors.fields)
      ) {
        errors = validator.validate(newField, validationRules.item);
      }

      return {
        ...state,
        validationRules: validationRules,
        errors: {
          ...state.errors,
          fields: errors ? errors : {},
        },
        apiErrors: {},
        formData: {
          ...newField,
        },
      };
    }

    case 'xeroSignup/SAVE': {
      const errors: KeyValue | null = validator.validate(
        state.formData,
        state.validationRules.item
      );

      return {
        ...state,
        errors: {
          ...state.errors,
          fields: errors || {},
        },
        hasSaved: true,
      };
    }

    case 'xeroSignup/SET_TENANT_ID': {
      const {tenantId} = action.payload;
      return {
        ...state,
        tenantId,
      };
    }

    default: {
      return state;
    }
  }
}
